import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@heroui/react";

import { DOCUMENTS } from "@/features/documents/types.ts";
import { DocumentEditor } from "@/features/documents/ui/document-editor.tsx";

export const Route = createFileRoute("/dashboard/documents")({
  component: RouteComponent,
});

function RouteComponent() {
  const [slug, setSlug] = useState<string>(DOCUMENTS[0].slug);

  return (
    <div className="flex flex-col pt-4 gap-4">
      <p className="font-bold text-xl">Документы</p>

      <div className="flex flex-row flex-wrap gap-2">
        {DOCUMENTS.map((d) => (
          <Button
            key={d.slug}
            variant={d.slug === slug ? "primary" : "ghost"}
            onPress={() => setSlug(d.slug)}
          >
            {d.title}
          </Button>
        ))}
      </div>

      <DocumentEditor key={slug} slug={slug} />
    </div>
  );
}
